<template>
  <div v-if="guid && !hasItems && (hasCOD || hasCodList)" class="vz-card text-h1 flex flex-space-between flex-align-items-center mt-20 px-20 py-30">
    <span class="mr-10">
      Наложенный платеж
    </span>
    <vz-button
      outline
      class="ml-auto"
      icon-name="plus"
      variant="info"
      @click="onOpenModal"
    >
      Добавить
    </vz-button>
  </div>
  <div
    v-else-if="hasItems || hasCodList"
    class="vz-card px-20 py-30"
  >
    <div class="text-h1 flex flex-space-between flex-align-items-center">
      <div class="flex flex-wrap flex-align-items-center flex-grow-1">
        <div class="mr-10">
          Наложенный платеж
        </div>
        <div
          v-if="!visible"
          class="text-h1 color-dark flex flex-align-items-center"
        >
          <vz-icon
            no-masked-icon
            size="16"
            class="mr-5"
            :url="flag"
          />
          <div>
            {{ totalPrice }}
            {{ currencyMeasure }}
          </div>
        </div>
      </div>
      <vz-button
        v-if="(hasCOD && hasCodItems && isNew)"
        outline
        class="ml-auto"
        icon-name="plus"
        variant="info"
        @click="onOpenModal"
      >
        Добавить
      </vz-button>
      <vz-button v-else-if="hasToggle" :icon-name="toggleIcon" rounded class="ml-auto" @click="visible = !visible" />
    </div>
    <div v-if="(hasCodList || hasItems) && visible" class="vz-cod-list">
      <div class="text-body-bold color-dark mb-10 mt-10">
        №{{ orderStore.codOrder }} от {{ date }}
      </div>

      <div
        v-for="(item, index) of orderStore.codList.list"
        :key="item.name+index"
        class="text-body color-dark mb-10 flex"
      >
        <div>{{ item.name }}</div>
        <div class="ml-auto">
          {{ item.quantity * item.price }} {{ currencyMeasure }}
        </div>
      </div>
      <hr style="border-top: 1px dashed #D9DCDE; position: relative; left: -20px; width: calc(100% + 40px); margin-top: 20px;">
      <div class="flex flex-align-items-center">
        <div class="text-subtitle color-dark">
          Итого:
        </div>
        <div class="ml-auto text-h1 color-dark flex flex-align-items-center">
          <vz-icon
            no-masked-icon
            size="16"
            class="mr-5"
            :url="flag"
          />
          <div>
            {{ totalPrice }}
            {{ currencyMeasure }}
          </div>
        </div>
      </div>
      <div class="flex flex-grow-1 flex-center">
        <vz-button
          v-if="canEdit"
          variant="primary"
          class="mt-25"
          @click="onOpenModal"
        >
          Редактировать
        </vz-button>
      </div>
    </div>
  </div>
  <div v-else-if="!guid && hasCOD" class="vz-card text-h1 flex flex-space-between flex-align-items-center mt-20 px-20 py-30">
    <div class="flex flex-wrap flex-align-items-center flex-grow-1">
      <div class="mr-10">
        Наложенный платеж
      </div>
      <div class="text-caption color-light mt-20">
        Наложенный платёж будет доступен после создания заказа
      </div>
    </div>
  </div>
  
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import {formatDate} from '~/common/date';
import {priceFormat} from '~/common/price';

const props = defineProps({
  hasToggle: {
    type: Boolean,
    default: true
  }
})
const { $showDialog } = useNuxtApp()
const orderStore = useOrderStore()

const visible = ref(true)

const guid = computed(() => {
  return useRoute().params.guid
})

const isNew = computed(() => {
  return !!guid.value
})

const hasItems = computed(() => {
  return orderStore.codList?.list?.length > 0 || false
})

const hasCodList = computed(() => {
  return orderStore.orderForm?.meta?.favorList?.codList || false
})

const canEdit = computed(() => {
  return orderStore.orderForm?.meta?.favorList?.codList
})

const hasCodItems = computed(() => {
  return orderStore.codList?.list?.length === 0 || false
})

const date = computed(() => {
  return formatDate(orderStore.codDate)
})

const currencyMeasure = computed(() => {
  return orderStore.orderPriceCurrency.currency
})

const toggleIcon = computed(() => {
  return visible.value ? 'chevron-up' : 'chevron-down'
})

const hasCOD = computed(() => {
  const { dispatch, destination, third, payer } = orderStore.orderForm.customer
  return dispatch.canEditCOD ||
    destination.canEditCOD ||
    (third.canEditCOD && (payer === 'third' || payer === 'segregated')) ||
    orderStore.orderForm?.meta?.favorList?.codList
})

const flag = computed(() => {
  return orderStore.orderPriceCurrency.flag
})

const totalPrice = computed(() => {
  let sum = 0
  if (orderStore.codList?.list?.length) {
    orderStore.codList.list.forEach((item) => {
      sum += item.quantity * item.price
    })
  }
  return priceFormat(sum)
})

function onOpenModal() {
  $showDialog({name: 'vz-pod-modal'})
}

onMounted(() => {
  if (!props.hasToggle) {
    visible.value = true
  }
})
</script>
